function applyMeta(routes) {
  return routes.map((route) => ({
    ...route,
    meta: {
      ...(route.meta || {}),
      category: 'nutrition',
    },
  }));
}

export default applyMeta([
  {
    path: '/Abslim',
    name: 'Abslim',
    component: () => import('../../components/Abslim.vue'),
  },
  {
    path: '/Apaizia',
    name: 'Apaizia',
    component: () => import('../../components/Apaizia.vue'),
  },
  {
    path: '/Artizynt',
    name: 'Artizynt',
    component: () => import('../../components/Artizynt.vue'),
  },
  {
    path: '/Artizynt2',
    name: 'Artizynt2',
    component: () => import('../../components/Artizynt2.vue'),
  },
  {
    path: '/ArtroFlex2',
    name: 'ArtroFlex2',
    component: () => import('../../components/ArtroFlex2.vue'),
  },
  {
    path: '/Artroflex',
    name: 'Artroflex',
    component: () => import('../../components/Artroflex.vue'),
  },
  {
    path: '/Artronol',
    name: 'Artronol',
    component: () => import('../../components/Artronol.vue'),
  },
  {
    path: '/Artronol2',
    name: 'Artronol2',
    component: () => import('../../components/Artronol2.vue'),
  },
  {
    path: '/Arthrovia',
    name: 'Arthrovia',
    component: () => import('../../components/Arthrovia.vue'),
  },
  {
    path: '/Balancio',
    name: 'Balancio',
    component: () => import('../../components/Balancio.vue'),
  },
  {
    path: '/Balancio2',
    name: 'Balancio2',
    component: () => import('../../components/Balancio2.vue'),
  },
  {
    path: '/Balancio3',
    name: 'Balancio3',
    component: () => import('../../components/Balancio3.vue'),
  },
  // {
  //   path: '/Biovancia',
  //   name: 'Biovancia',
  //   component: () => import('../../components/Biovancia.vue'),
  // },
  {
    path: '/Biovancia2',
    name: 'Biovancia2',
    component: () => import('../../components/Biovancia2.vue'),
  },
  {
    path: '/calm',
    name: 'Calm',
    component: () => import('../../components/Calm.vue'),
  },
  {
    path: '/calm1',
    name: 'Calm1',
    component: () => import('../../components/Calm1.vue'),
  },
  {
    path: '/calm2',
    name: 'Calm2',
    component: () => import('../../components/Calm2.vue'),
  },
  {
    path: '/CardioGenix',
    name: 'CardioGenix',
    component: () => import('../../components/CardioGenix.vue'),
  },
  {
    path: '/CardioGenix2',
    name: 'CardioGenix2',
    component: () => import('../../components/CardioGenix2.vue'),
  },
  {
    path: '/CardioGenix3',
    name: 'CardioGenix3',
    component: () => import('../../components/CardioGenix3.vue'),
  },
  {
    path: '/Cardiotens',
    name: 'Cardiotens',
    component: () => import('../../components/Cardiotens.vue'),
  },
  {
    path: '/Cardiotens2',
    name: 'Cardiotens2',
    component: () => import('../../components/Cardiotens2.vue'),
  },
  {
    path: '/Collacare',
    name: 'Collacare',
    component: () => import('../../components/Collacare.vue'),
  },
  {
    path: '/Cystonette',
    name: 'Cystonette',
    component: () => import('../../components/Cystonette.vue'),
  },
  {
    path: '/Desparazil',
    name: 'Desparazil',
    component: () => import('../../components/Desparazil.vue'),
  },
  {
    path: '/Desparazil2',
    name: 'Desparazil2',
    component: () => import('../../components/Desparazil2.vue'),
  },
  {
    path: '/Diaformrx',
    name: 'Diaformrx',
    component: () => import('../../components/Diaformrx.vue'),
  },
  {
    path: '/Dianol',
    name: 'Dianol',
    component: () => import('../../components/Dianol.vue'),
  },
  {
    path: '/Diofin',
    name: 'Diofin',
    component: () => import('../../components/Diofin.vue'),
  },
  {
    path: '/EarlickForte',
    name: 'EarlickForte',
    component: () => import('../../components/EarlickForte.vue'),
  },
  {
    path: '/Fleboxin',
    name: 'Fleboxin',
    component: () => import('../../components/Fleboxin.vue'),
  },
  {
    path: '/Flexosamine',
    name: 'Flexosamine',
    component: () => import('../../components/Flexosamine.vue'),
  },
  {
    path: '/Flexosamine2',
    name: 'Flexosamine2',
    component: () => import('../../components/Flexosamine2.vue'),
  },
  {
    path: '/Flexosamine3',
    name: 'Flexosamine3',
    component: () => import('../../components/Flexosamine3.vue'),
  },
  {
    path: '/FungoKiller',
    name: 'FungoKiller',
    component: () => import('../../components/FungoKiller.vue'),
  },
  {
    path: '/GLPPatch',
    name: 'GLPPatch',
    component: () => import('../../components/GLPPatch.vue'),
  },
  {
    path: '/Glucavit',
    name: 'Glucavit',
    component: () => import('../../components/Glucavit.vue'),
  },
  {
    path: '/Hairflex',
    name: 'Hairflex',
    component: () => import('../../components/Hairflex.vue'),
  },
  {
    path: '/Health',
    name: 'Health',
    component: () => import('../../components/Health.vue'),
  },
  {
    path: '/Herbolo',
    name: 'Herbolo',
    component: () => import('../../components/Herbolo.vue'),
  },
  {
    path: '/Hondro',
    name: 'Hondro',
    component: () => import('../../components/Hondro.vue'),
  },
  {
    path: '/HondroLife',
    name: 'HondroLife',
    component: () => import('../../components/HondroLife.vue'),
  },
  {
    path: '/idealfit',
    name: 'idealfit',
    component: () => import('../../components/idealfit.vue'),
  },
  {
    path: '/Idealfit2',
    name: 'Idealfit2',
    component: () => import('../../components/Idealfit2.vue'),
  },
  {
    path: '/Ketonic',
    name: 'Ketonic',
    component: () => import('../../components/Ketonic.vue'),
  },
  {
    path: '/KetoPlus',
    name: 'KetoPlus',
    component: () => import('../../components/KetoPlus.vue'),
  },
  {
    path: '/Keranique',
    name: 'Keranique',
    component: () => import('../../components/Keranique.vue'),
  },
  {
    path: '/Lacrea',
    name: 'Lacrea',
    component: () => import('../../components/Lacrea.vue'),
  },
  {
    path: '/Lacrea2',
    name: 'Lacrea2',
    component: () => import('../../components/Lacrea2.vue'),
  },
  {
    path: '/Noom',
    name: 'Noom',
    component: () => import('../../components/Noom.vue'),
  },
  {
    path: '/Nutrilaben',
    name: 'Nutrilaben',
    component: () => import('../../components/Nutrilaben.vue'),
  },
  {
    path: '/Optipills',
    name: 'Optipills',
    component: () => import('../../components/Optipills.vue'),
  },
  {
    path: '/Osteon',
    name: 'Osteon',
    component: () => import('../../components/Osteon.vue'),
  },
  {
    path: '/Osteomeo',
    name: 'Osteomeo',
    component: () => import('../../components/Osteomeo.vue'),
  },
  {
    path: '/PAINRELIEFCream',
    name: 'PAINRELIEFCream',
    component: () => import('../../components/PAINRELIEFCream.vue'),
  },
  {
    path: '/Predstonorm',
    name: 'Predstonorm',
    component: () => import('../../components/Predstonorm.vue'),
  },
  {
    path: '/Prostalis',
    name: 'Prostalis',
    component: () => import('../../components/Prostalis.vue'),
  },
  {
    path: '/Retoxin',
    name: 'Retoxin',
    component: () => import('../../components/Retoxin.vue'),
  },
  {
    path: '/Semaglutide',
    name: 'Semaglutide',
    component: () => import('../../components/Semaglutide.vue'),
  },
  {
    path: '/Slimmatica',
    name: 'Slimmatica',
    component: () => import('../../components/Slimmatica.vue'),
  },
  {
    path: '/TestoLink',
    name: 'TestoLink',
    component: () => import('../../components/TestoLink.vue'),
  },
  {
    path: '/Transplant',
    name: 'Transplant',
    component: () => import('../../components/Transplant.vue'),
  },
  {
    path: '/Vidalyn',
    name: 'Vidalyn',
    component: () => import('../../components/Vidalyn.vue'),
  },
  {
    path: '/VistaFocus',
    name: 'VistaFocus',
    component: () => import('../../components/VistaFocus.vue'),
  },
]);
